// Archivo: src/components/ScrollToTop.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Este componente no renderiza nada visualmente. Su única función es
// ejecutar un efecto secundario (scrollear hacia arriba) cuando cambia la ruta.
export default function ScrollToTop() {
  // Obtenemos la información de la ubicación actual, incluyendo el pathname (ej: "/quienes-somos")
  const { pathname } = useLocation();

  // Usamos useEffect para ejecutar un código cada vez que el 'pathname' cambie.
  useEffect(() => {
    // Esta es la función mágica: le dice al navegador que se mueva
    // a la posición 0 en el eje X y 0 en el eje Y (el inicio de la página).
    window.scrollTo(0, 0);
  }, [pathname]); // El array de dependencias asegura que el efecto solo se ejecute si la URL cambia.

  // Como este componente es solo para la lógica, no necesita devolver ningún HTML.
  return null;
}
